module.exports = __webpack_public_path__ + "static/img/ffxiv-blue-logo.7a086b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ffxiv-blue-logo.png
// module id = IjG5
// module chunks = 1